class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }
static initPriceRangeSlider() {

  if (!window.noUiSlider) return;

  document.querySelectorAll('.price-slider').forEach((slider) => {

    // Prevent duplicate initialization
    if (slider.classList.contains('noUi-target')) return;

    var minRange = parseFloat(slider.dataset.minRange);
    var maxRange = parseFloat(slider.dataset.maxRange);

    function getUrlParam(param) {
      var urlParams = new URLSearchParams(window.location.search);

      return urlParams.has(param)
        ? parseFloat(urlParams.get(param))
        : null;
    }

    var urlMin = getUrlParam('filter.v.price.gte');
    var urlMax = getUrlParam('filter.v.price.lte');

    var startMin = (!isNaN(urlMin) && urlMin !== null)
      ? urlMin
      : minRange;

    var startMax = (!isNaN(urlMax) && urlMax !== null)
      ? urlMax
      : maxRange;

    noUiSlider.create(slider, {
      start: [startMin, startMax],
      connect: true,
      step: 1,
      range: {
        min: minRange,
        max: maxRange
      }
    });

    const wrapper = slider.closest('.price-filter-wrapper');

    if (!wrapper) return;

    const lowerInput = wrapper.querySelector('.lower-input');
    const upperInput = wrapper.querySelector('.upper-input');

    const minBox = wrapper.querySelector('.min-box');
    const maxBox = wrapper.querySelector('.max-box');

    if (!lowerInput || !upperInput || !minBox || !maxBox) return;

    lowerInput.value = startMin;
    upperInput.value = startMax;

    minBox.textContent = startMin;
    maxBox.textContent = startMax;

    slider.noUiSlider.on('update', function(values) {

      var v0 = Math.round(values[0]);
      var v1 = Math.round(values[1]);

      if (lowerInput.value != v0) {
        lowerInput.value = v0;
        lowerInput.dispatchEvent(
          new Event('input', { bubbles: true })
        );
      }

      if (upperInput.value != v1) {
        upperInput.value = v1;
        upperInput.dispatchEvent(
          new Event('input', { bubbles: true })
        );
      }

      minBox.textContent = v0;
      maxBox.textContent = v1;
    });

    lowerInput.addEventListener('change', function () {
      slider.noUiSlider.set([this.value, null]);
    });

    upperInput.addEventListener('change', function () {
      slider.noUiSlider.set([null, this.value]);
    });

  });
}
  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
   setTimeout(() => {
  FacetFiltersForm.initPriceRangeSlider();
}, 150);
    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
// class PriceRange extends HTMLElement { 
//   constructor() {
//     super();

//     // existing Dawn-style logic
//     this.querySelectorAll('input').forEach((element) => {
//       element.addEventListener('change', this.onRangeChange.bind(this));
//       element.addEventListener('keydown', this.onKeyDown.bind(this));
//     });

//     // cache slider + labels
//     this.lower = this.querySelector('#lower');
//     this.upper = this.querySelector('#upper');
//     this.minBox = this.querySelector('#min-box');
//     this.maxBox = this.querySelector('#max-box');
//     this.sliderElement = this.querySelector('#slider');

//     this.setMinAndMaxValues();
//     this.initSliderLabels();
    
//     // Initialize noUiSlider after DOM is ready
//     this.initNoUiSlider();
//   }

//   initNoUiSlider() {
//     if (!this.sliderElement || !window.noUiSlider) {
//       console.warn('noUiSlider not found or slider element missing');
//       return;
//     }
    
//     // Prevent duplicate initialization
//     if (this.sliderElement.noUiSlider) {
//       this.sliderElement.noUiSlider.destroy();
//     }

//     const min = parseFloat(this.sliderElement.dataset.min);
//     const max = parseFloat(this.sliderElement.dataset.max);

//     // Get current values from inputs (could be from URL params)
//     const currentMin = parseFloat(this.lower.value) || min;
//     const currentMax = parseFloat(this.upper.value) || max;

//     // Create the slider
//     noUiSlider.create(this.sliderElement, {
//       start: [currentMin, currentMax],
//       connect: true,
//       range: { 
//         min: min, 
//         max: max 
//       },
//       step: 1,
//       format: {
//         to: function(value) {
//           return Math.round(value);
//         },
//         from: function(value) {
//           return Number(value);
//         }
//       }
//     });

//     // Update inputs and trigger filtering when slider changes
//     this.sliderElement.noUiSlider.on('update', (values, handle) => {
//       const v0 = Math.round(values[0]);
//       const v1 = Math.round(values[1]);

//       // Update the hidden range inputs
//       if (this.lower.value != v0) {
//         this.lower.value = v0;
//       }
//       if (this.upper.value != v1) {
//         this.upper.value = v1;
//       }

//       // Update visible labels
//       this.minBox.textContent = this.formatCurrency(v0);
//       this.maxBox.textContent = this.formatCurrency(v1);
//     });

//     // Trigger change event when user releases the slider (to apply filters)
//     this.sliderElement.noUiSlider.on('change', (values, handle) => {
//       const v0 = Math.round(values[0]);
//       const v1 = Math.round(values[1]);

//       this.lower.value = v0;
//       this.upper.value = v1;

//       // Trigger the change event to apply filters
//       this.lower.dispatchEvent(new Event('change', { bubbles: true }));
//       this.upper.dispatchEvent(new Event('change', { bubbles: true }));
//     });

//     // Optional: Sync manual input changes back to slider
//     this.lower.addEventListener('change', () => {
//       if (this.sliderElement.noUiSlider) {
//         this.sliderElement.noUiSlider.set([this.lower.value, null]);
//       }
//     });

//     this.upper.addEventListener('change', () => {
//       if (this.sliderElement.noUiSlider) {
//         this.sliderElement.noUiSlider.set([null, this.upper.value]);
//       }
//     });
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//     this.updateSliderLabels();
    
//     // Update slider if it exists
//     if (this.sliderElement && this.sliderElement.noUiSlider) {
//       this.sliderElement.noUiSlider.set([this.lower.value, this.upper.value]);
//     }
//   }

//   onKeyDown(event) {
//     if (event.metaKey) return;

//     const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
//     if (!event.key.match(pattern)) event.preventDefault();
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input[type="range"]');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];

//     if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('data-min', 0);
//     if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('data-min'));
//     const max = Number(input.getAttribute('data-max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }

//   initSliderLabels() {
//     if (!this.lower || !this.upper || !this.minBox || !this.maxBox) return;

//     // initial from attributes (includes URL filter values if present)
//     const urlParams = new URLSearchParams(window.location.search);
//     const urlMin = urlParams.get(this.lower.name);
//     const urlMax = urlParams.get(this.upper.name);

//     const dataMin = parseFloat(this.lower.dataset.min);
//     const dataMax = parseFloat(this.upper.dataset.max);
//     const minAttr = parseFloat(this.lower.min);
//     const maxAttr = parseFloat(this.upper.max);

//     let minVal = urlMin ? parseFloat(urlMin) : dataMin;
//     let maxVal = urlMax ? parseFloat(urlMax) : dataMax;

//     minVal = Math.max(minVal, minAttr);
//     maxVal = Math.min(maxVal, maxAttr);

//     this.lower.value = minVal;
//     this.upper.value = maxVal;

//     this.updateSliderLabels();

//     // keep labels in sync while dragging
//     this.lower.addEventListener('input', () => this.handleLowerInput());
//     this.upper.addEventListener('input', () => this.handleUpperInput());
//   }

//   handleLowerInput() {
//     if (!this.lower || !this.upper) return;
//     let lv = parseFloat(this.lower.value);
//     const uv = parseFloat(this.upper.value);
//     if (lv > uv) {
//       lv = uv;
//       this.lower.value = lv;
//     }
//     this.updateSliderLabels();
    
//     // Update noUiSlider
//     if (this.sliderElement && this.sliderElement.noUiSlider) {
//       this.sliderElement.noUiSlider.set([lv, null]);
//     }
//   }

//   handleUpperInput() {
//     if (!this.lower || !this.upper) return;
//     const lv = parseFloat(this.lower.value);
//     let uv = parseFloat(this.upper.value);
//     if (uv < lv) {
//       uv = lv;
//       this.upper.value = uv;
//     }
//     this.updateSliderLabels();
    
//     // Update noUiSlider
//     if (this.sliderElement && this.sliderElement.noUiSlider) {
//       this.sliderElement.noUiSlider.set([null, uv]);
//     }
//   }

//   updateSliderLabels() {
//     if (!this.minBox || !this.maxBox || !this.lower || !this.upper) return;
//     const minVal = parseFloat(this.lower.value || this.lower.min);
//     const maxVal = parseFloat(this.upper.value || this.upper.max);
//     this.minBox.textContent = this.formatCurrency(minVal);
//     this.maxBox.textContent = this.formatCurrency(maxVal);
//   }

//   formatCurrency(value) {
//     // You can customize this to include currency symbol
//     return Math.round(value);
//   }

//   reset() {
//     // clear any input values so min/max fall back to full range
//     if (this.lower) this.lower.value = this.lower.min || this.lower.dataset.min;
//     if (this.upper) this.upper.value = this.upper.max || this.upper.dataset.max;

//     this.setMinAndMaxValues();
//     this.updateSliderLabels();
    
//     // Reset noUiSlider
//     if (this.sliderElement && this.sliderElement.noUiSlider) {
//       const min = parseFloat(this.sliderElement.dataset.min);
//       const max = parseFloat(this.sliderElement.dataset.max);
//       this.sliderElement.noUiSlider.set([min, max]);
//     }
//   }
// }

// customElements.define('price-range', PriceRange)

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
